import $ from 'jquery';

require('slick-slider');

$(document).ready(() => {
	$('.gallery').slick({
		arrows: true,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
	});
});



// WEBPACK FOOTER //
// ./src/js/components/gallery.js